export default __webpack_public_path__ + "static/media/03.ff873054.png";